import { addNotify } from 'features/notify';

import { getErrorMessage } from 'shared/helpers/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'domains/ACTION_PROCESSING',
  GET_DOMAINS: 'domains/GET_DOMAINS',
};

function getDomains(params) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const response = await api.agentAdmin.getDomains(params);

    if (response.success) {
      dispatch({
        type: actionTypes.GET_DOMAINS,
        payload: response.data,
      });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }

    dispatch({
      type: actionTypes.ACTION_PROCESSING,
      payload: false,
    });

    return response;
  };
}

function getMyDomains(params) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const response = await api.agentAdmin.getMyDomains(params);

    if (response.success) {
      dispatch({
        type: actionTypes.GET_DOMAINS,
        payload: response.data,
      });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }

    dispatch({
      type: actionTypes.ACTION_PROCESSING,
      payload: false,
    });

    return response;
  };
}

function sendDomainRequest(params, callback) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const response = await api.agentAdmin.sendDomainRequest(params);

    if (response.success) {
      dispatch({
        type: actionTypes.GET_DOMAINS,
        payload: response.data,
      });
      dispatch(addNotify(locale.defaultSuccess, 'success'));

      if (callback) {
        console.log('callback');
        callback();
      }
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }

    dispatch({
      type: actionTypes.ACTION_PROCESSING,
      payload: false,
    });
  };
}

export { actionTypes, getDomains, getMyDomains, sendDomainRequest };
